document.addEventListener('DOMContentLoaded', function () {
    const faqQuestions = document.querySelectorAll('.faq-question');

    faqQuestions.forEach(function (question) {
        question.addEventListener('click', function () {
            const answer = this.nextElementSibling;

            if (answer && answer.classList.contains('faq-answer')) {
                answer.style.display =
                    answer.style.display === 'none' || answer.style.display === ''
                        ? 'block'
                        : 'none';
            }
        });
    });
});

const bulletContainers = document.querySelectorAll(".bullet_point, .pbpoint-list");

bulletContainers.forEach((container) => {

    const items = container.matches(".bullet_point")
        ? container.querySelectorAll("p")
        : container.querySelectorAll("li");

    if (items.length > 3) {

        // Hide after 3 items
        items.forEach((item, index) => {

            if (index > 2) {
                item.style.display = "none";
            }

        });

        // Create button
        const moreBtn = document.createElement("a");

        moreBtn.href = "#";
        moreBtn.innerText = "More Benefits";
        moreBtn.classList.add("bullet_point_more");

        container.after(moreBtn);

        // Click Event
        moreBtn.addEventListener("click", function (e) {

            e.preventDefault();

            items.forEach((item) => {

                if (container.matches(".bullet_point")) {
                    item.style.display = "flex";
                } else {
                    item.style.display = "list-item";
                }

            });

            moreBtn.remove();

        });

    }

});

(function () {
    // chatbot-root ke andar Shadow DOM hai, isliye normal CSS selector
    // is widget ke andar ke element ko touch nahi kar sakta — z-index
    // sirf JS se, shadow root ke andar jaake, set karna padega.
    function fixChatbotZIndex() {
        const chatbotRoot = document.getElementById('chatbot-root');
        if (!chatbotRoot || !chatbotRoot.shadowRoot) return;

        const widgetContainer = chatbotRoot.shadowRoot.querySelector('.fixed.flex.flex-col');
        if (widgetContainer && widgetContainer.style.zIndex !== '49') {
            widgetContainer.style.setProperty('z-index', '49', 'important');
        }
    }

    function watchChatbotRoot() {
        const chatbotRoot = document.getElementById('chatbot-root');
        if (!chatbotRoot || !chatbotRoot.shadowRoot) return;

        fixChatbotZIndex();

        // widget apna UI baar-baar re-render karta hai aur z-index reset kar deta hai,
        // isliye shadow root ke andar style change hote hi dobara apply karo
        const shadowWatcher = new MutationObserver(fixChatbotZIndex);
        shadowWatcher.observe(chatbotRoot.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style'],
        });
    }

    // chatbot-root khud page load hone ke baad inject hota hai,
    // isliye jab tak wo DOM me na aa jaye tab tak wait karo
    if (document.getElementById('chatbot-root')) {
        watchChatbotRoot();
    } else {
        const bodyWatcher = new MutationObserver(function (mutations, observerInstance) {
            if (document.getElementById('chatbot-root')) {
                watchChatbotRoot();
                observerInstance.disconnect();
            }
        });
        bodyWatcher.observe(document.documentElement, { childList: true, subtree: true });
    }
})();

// const bulletPoint = document.querySelector(".bullet_point");
// const bulletPointItem = document.querySelectorAll(".bullet_point p");

// if (bulletPointItem.length > 3) {

//     // Hide items after 3
//     bulletPointItem.forEach((item, index) => {

//         if (index > 2) {
//             item.style.display = "none";
//         }

//     });

//     // Create Read More button
//     const bulletPointMore = document.createElement("a");

//     bulletPointMore.href = "#";
//     bulletPointMore.innerText = "More Benefits";
//     bulletPointMore.classList.add("bullet_point_more");

//     // Add button after grid
//     bulletPoint.after(bulletPointMore);

//     // Click Event
//     bulletPointMore.addEventListener("click", function (e) {

//         e.preventDefault();

//         bulletPointItem.forEach((item) => {
//             item.style.display = "flex";
//         });

//         bulletPointMore.remove();

//     });

// }